import { render } from "./GenericBanner.vue?vue&type=template&id=39243282&scoped=true&ts=true"
import script from "./GenericBanner.vue?vue&type=script&lang=ts"
export * from "./GenericBanner.vue?vue&type=script&lang=ts"

import "./GenericBanner.vue?vue&type=style&index=0&id=39243282&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\102\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39243282"]])

export default __exports__